<template>
  <ValidationObserver
    ref="form"
    v-slot="{ handleSubmit }"
    slim
  >
    <form
      role="form"
      class="user form-horizontal"
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <fieldset>
        <Field
          :label="$t('INPUT_LABEL_URL_PARAMETER')"
          :has-tooltip="true"
          :tooltip-text="$t('INPUT_LABEL_URL_PARAMETER_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="incomingQueryStringName"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="urlParameter.incomingQueryStringName"
                    type="text"
                    name="incomingQueryStringName"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        
        <Field
          :label="$t('INPUT_LABEL_REPORTING_MENU_NAME')"
          :has-tooltip="true"
          :tooltip-text="$t('INPUT_LABEL_REPORTING_MENU_NAME_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="mapToTagType"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="urlParameter.mapToTagType"
                    :placeholder="$t('USER_TEXT')"
                    type="text"
                    name="mapToTagType"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('INPUT_LABEL_REPORT_NAME')"
          :has-tooltip="true"
          :tooltip-text="$t('INPUT_LABEL_REPORT_NAME_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              ref="mapToTagName"
              rules="required"
              slim
            >
              <div :class="classes">
                <div class="col-sm-4 col-md-3">
                  <input
                    v-model="urlParameter.mapToTagName"
                    type="text"
                    name="mapToTagName"
                    autocomplete="off"
                    class="form-control"
                  >
                </div>                   
                <label 
                  v-t="'REQUIRED'"
                  class="col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>

        <div class="form-group">
          <div class="col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3">            
            <PrimaryButton
              size="sm"
              :show-loader-on-form="showLoader"
            >
              <span v-t="isNewUrlParameter ? 'CREATE' : 'UPDATE'" />
            </PrimaryButton>

            <button
              v-t="'CANCEL'"
              class="btn btn-sm btn-danger m-l-15"
              @click="cancel"
            />
          </div>
        </div>
      </fieldset>
    </form>
  </ValidationObserver>
</template>>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import PrimaryButton from '@/core/components/PrimaryButton';

export default {
  name: 'UrlParameterForm',
  components: { Field, PrimaryButton },
  props: {
    showLoader: {
      type: Boolean,
      default: () => true
    }, 
    currentUrlParameter: {
      type: Object,
      default: function() {
        return {};
      }
    },
    isNewUrlParameter: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    urlParameter() { return _.cloneDeep(this.currentUrlParameter); }
  },
  methods:{
    onSubmit() {
      this.$emit('submit', this.urlParameter);
    },
    cancel() {
      this.$emit('cancel', this.urlParameter);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
};
</script>